/**
 * 00main.js
 */

import '/style.css'

// fixes mobile browsers 100vh issue
// from https://web.archive.org/web/20220618161902/https://dev.to/nirazanbasnet/dont-use-100vh-for-mobile-responsive-3o97
const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

// const titleSection = {
//     container: document.querySelector('#titleSectionContainer'),
// };
const myselfSection = {
    container: document.querySelector('#myselfSectionContainer'),
};
const mySkillsSection = {
    container: document.querySelector('.skills').querySelector(".section-inside-container"),
}

const setPortraitStyle = () => {
    // myProjectSections defined inside handleSections.js
    sensibleToOrientationSections.forEach(sectionWrap => {
        // title and description
        sectionWrap.container.children[0].classList.remove('h-full');
        sectionWrap.container.children[0].classList.add('w-full');
        sectionWrap.container.children[0].classList.remove('w-1/2');
        sectionWrap.container.children[0].classList.add('h-1/2');

        // canvas container
        sectionWrap.container.children[1].classList.remove('h-full');
        sectionWrap.container.children[1].classList.add('w-full');
        sectionWrap.container.children[1].classList.remove('w-3-on5');
        sectionWrap.container.children[1].classList.add('h-3on5');
        sectionWrap.container.children[1].classList.remove('right-0.5');
        sectionWrap.container.children[1].classList.add('bottom-0');
        sectionWrap.container.children[1].classList.add('left-0');

        if(sectionWrap.projectIndex!=null){
            // project index
            sectionWrap.projectIndex.classList.remove('px-10');
            sectionWrap.projectIndex.classList.remove('py-10');
            sectionWrap.projectIndex.classList.add('px-4');
            sectionWrap.projectIndex.classList.add('py-4');
        } // else: not a project section
    });

    if( window.matchMedia("(max-width: 600px)").matches ){
        mySkillsSection.container.children[0].
            children[0].classList.remove('left-1/4');
        mySkillsSection.container.children[0].
            children[0].classList.remove('px-10');
        mySkillsSection.container.children[0].
            children[0].classList.add('px-4');
        mySkillsSection.container.children[1].
            children[0].classList.remove('left-10perc');
    }
}

// popup
const popup = document.querySelector("#popup");

// sections
let sensibleToOrientationSections = [];
const onSectionVisible = [];
const onSectionGone = [];
const loadScene = []; // canvasMain
const projectIndexOffset = 1; // # of sections before first project

const allProjects = [
    {
        visible: true,
        title: 'WeClubs',
        subscript: 'iOS / Android App',
        url: 'https://apps.apple.com/it/app/weclubs/id6450907837',
        link_text: '<i class="fa-brands fa-app-store-ios project-description text-black"></i>',
        roles: 'Full-stack Developer',
        description: 'Real-time sharing platform to live directly inside your favorite venues.\
                        Allows the access to a Social Room by scanning a Qr Code at the entrance of the venue,\
                        in which you will find only those present at the event.',
        technologies_presentation: '<li><i class="fab fa-android"></i></li>\
                                    <li><i class="fa-brands fa-apple"></i></li>\
                                    <li><i class="fab fa-node"></i></li>\
                                    <li><i class="fa-solid fa-network-wired"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fa-brands fa-apple"></i></li>\
                                    <li><i class="fab fa-node"></i></li>\
                                    <li><i class="fa-solid fa-network-wired"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fa-brands fa-apple"></i></li>\
                                    <li><i class="fab fa-node"></i></li>\
                                    <li><i class="fa-solid fa-network-wired"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>',
        type: 'phone_scene',
        model_path: './models/phone/weclubs'
    },
    {
        visible: true,
        title: 'Analysis of kinematic data',
        subscript: 'Data analyst',
        url: 'https://www.amorelli-lorenzo.it/personale/Tesi_di_laurea%20Amorelli_Lorenzo.pdf',
        link_text: '<i class="bi bi-mortarboard-fill project-description text-black"></i>',
        roles: 'Data Analysis',
        description: 'Dashboard for the AInCP project and analysis of kinematic data for the diagnosis of cerebral hemiparesis.',
        technologies_presentation: '<li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-chart-pie"></i></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-chart-pie"></i></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-chart-pie"></i></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-chart-pie"></i></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-chart-pie"></i></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>',
        type: 'desktop_scene',
        video_id: 'thesispresentationvideo',
        video_url: './assets/video/analisipres.mp4'
    },
    {
        visible: true,
        title: 'Remote Linking for <i>MyBoy!</i>',
        subscript: 'Android App',
        url: 'https://play.google.com/store/apps/details?id=com.donow.myboyremotelinking',
        link_text: '<i class="fa-brands fa-google-play project-description text-black"></i>',
        roles: 'Full-stack Developer',
        description: 'It is used for remotely link <i>MyBoy!</i> and <i>MyOldBoy!</i> emulators.\
                        It makes it possible to play gameboy games over the net.',
        technologies_presentation: '<li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-node"></i></li>\
                                    <li><i class="fa-solid fa-network-wired"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-node"></i></li>\
                                    <li><i class="fa-solid fa-network-wired"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-node"></i></li>\
                                    <li><i class="fa-solid fa-network-wired"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fab fa-java"></i></li>',
        type: 'phone_scene',
        model_path: './models/phone/remotelinkingformyboyapp'
    },
    {
        visible: true,
        title: 'My Sport Club',
        subscript: 'Android App Prototype',
        url: 'https://github.com/mikeabbott10/My-sport-club',
        link_text: '<i class="fab fa-github project-description text-black"></i>',
        roles: 'Full-stack Developer • UI/UX Designer',
        description: 'It lets sport club fans to keep in close contact with players and sport society.\
                        Latest news and updated league standings at user fingertips.',
        technologies_presentation: '<li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>',
        type: 'phone_scene',
        model_path: './models/phone/volleycecinaapp'
    },
    {
        visible: true,
        title: 'React Fast Guide',
        subscript: 'ReactJS library',
        url: 'https://mikeabbott10.github.io/fast-guide-io',
        link_text: '<i class="fab fa-github project-description text-black"></i>',
        roles: 'Front-end Developer',
        description: 'It is a light component for ReactJS that makes it simple to show guides inside web applications.',
        technologies_presentation: '<li><i class="fa-brands fa-npm"></i></li>\
                                    <li><i class="fa-brands fa-yarn"></i></li>\
                                    <li><i class="fa-brands fa-react"></i></li>\
                                    <li><svg height="24" width="24" style="color: white" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>TypeScript</title><path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z" fill="white"></path></svg></li>\
                                    <li><i class="fa-brands fa-npm"></i></li>\
                                    <li><i class="fa-brands fa-yarn"></i></li>\
                                    <li><i class="fa-brands fa-react"></i></li>\
                                    <li><svg height="24" width="24" style="color: white" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>TypeScript</title><path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z" fill="white"></path></svg></li>\
                                    <li><i class="fa-brands fa-npm"></i></li>\
                                    <li><i class="fa-brands fa-yarn"></i></li>\
                                    <li><i class="fa-brands fa-react"></i></li>\
                                    <li><svg height="24" width="24" style="color: white" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>TypeScript</title><path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z" fill="white"></path></svg></li>\
                                    <li><i class="fa-brands fa-npm"></i></li>\
                                    <li><i class="fa-brands fa-yarn"></i></li>\
                                    <li><i class="fa-brands fa-react"></i></li>\
                                    <li><svg height="24" width="24" style="color: white" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>TypeScript</title><path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z" fill="white"></path></svg></li>\
                                    ',
        type: 'phone_scene',
        model_path: './models/phone/reactfastguide'
    },
    {
        visible: false,
        title: 'VolleyCecina.it',
        subscript: 'Web App',
        url: 'https://amorelli-lorenzo.it/personale/volleycecina',
        link_text: '<i class="fa-solid fa-arrow-up-right-from-square project-description text-black"></i>',
        roles: 'Full-stack Developer • UI/UX Designer',
        description: 'Web app for Volley Cecina volleyball club. It allows people to get updated and allows insiders to enter/edit news, people, teams, etc.',
        technologies_presentation: '<li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fa-brands fa-bootstrap"></i></li>\
                                    <li><i class="fa-brands fa-php"></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fa-brands fa-bootstrap"></i></li>\
                                    <li><i class="fa-brands fa-php"></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fa-brands fa-bootstrap"></i></li>\
                                    <li><i class="fa-brands fa-php"></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>\
                                    <li><i class="fa-brands fa-square-js"></i></li>\
                                    <li><i class="fa-brands fa-bootstrap"></i></li>\
                                    <li><i class="fa-brands fa-php"></i></li>\
                                    <li><i class="fa-solid fa-database"></i></li>',
        type: 'desktop_scene',
        video_id: 'volleycecinavideo',
        video_url: './assets/video/volleycecina.mp4'
    },
    {
        visible: false,
        title: 'Body tracker',
        subscript: 'Android App Prototype',
        url: 'https://github.com/mikeabbott10/Body-tracker',
        link_text: '<i class="fab fa-github project-description text-black"></i>',
        roles: 'Front-end Developer • UI/UX Designer',
        description: 'It detects body movements and sends the data obtained\
                        from the sensors of the player device,\
                        to the coach device via bluetooth.',
        technologies_presentation: '<li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-bluetooth"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-bluetooth"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-bluetooth"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>\
                                    <li><i class="fab fa-github"></i></li>\
                                    <li><i class="fab fa-bluetooth"></i></li>\
                                    <li><i class="fab fa-android"></i></li>\
                                    <li><i class="fab fa-java"></i></li>',
        type: 'phone_scene',
        model_path: './models/phone/bodytrackerapp'
    },
    {
        visible: false,
        title: 'AutOMG',
        subscript: 'Automation App',
        url: 'https://github.com/mikeabbott10/AutOMG',
        link_text: '<i class="fab fa-github project-description text-black"></i>',
        roles: 'Developer',
        description: 'It is used for automate (record and play) mouse actions sequences and map keyboard keys to mouse clicks on the screen.',
        technologies_presentation: '<li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>\
                                    <li><i class="fa-brands fa-python"></i></li>\
                                    <li><i class="fa-solid fa-robot"></i></li>',
        type: 'desktop_scene',
        video_id: 'automgvideo',
        video_url: './assets/video/automg.mp4'
    },
]

const projects = allProjects.filter(p => p.visible);

function initSectionsContents(projects){
    let i = 1;
    const projContainer = document.getElementById('project_container');
    projects.forEach( ( proj, currentProjectIndex ) => {
        let c = '\
            <section class="sensible-to-orientation-section">\
            <div class="outer">\
            <div class="inner">\
                <div class="bg">\
                <div class="section-inside-container invisible items-center justify-center h-screen"\
                    style="position:absolute; left:1px; right:1px;">\
                    <div class="fixed h-full w-1/2 left-0">\
                    <div class="fixed top-0 left-0 rotate--45">\
                        <div class="marquee ">\
                        <ul class="marquee-content">\
                        '+proj.technologies_presentation+'</ul>\
                        </div>\
                    </div>\
                    <div class="project-index fixed px-10 py-10 bottom-0 left-0">\
                        <p class="project-description uppercase text-black description-font font-semibold text-left text-gray-800">\
                        '+i.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                          })+ ' • ' +proj.subscript +'\
                        </p>\
                    </div>\
                    <div class="absolute top-18perc left-10perc px-10">\
                        <h3 class="project-title py-2.5 text-black title-font text-left text-gray-800">\
                        '+proj.title+'\
                        <a href="'+proj.url+'" target="_blank">\
                            '+proj.link_text+'\
                        </a>\
                        </h3>\
                        <p class="project-description py-1 text-black second-title-font text-left text-gray-800 font-medium">\
                        ‣ '+proj.roles+'\
                        </p>\
                        <p class="project-description text-black description-font text-left text-gray-700">\
                        '+proj.description+'\
                        </p>\
                    </div>\
                    </div>\
                    <div class="invisible fixed h-full w-3-on5 right-0.5 canvasContainer">\
                    <canvas></canvas>\
                    </div>\
                </div>\
                </div>\
            </div>\
            </div>\
        </section>\
        '+ (proj.type==='desktop_scene' ?
                '<video id="'+proj.video_id+'" playsinline webkit-playsinline loop autoplay muted\
                width="1920" height="1080" style="display: none;" \
                src="'+proj.video_url+'"></video>' : '');
        projContainer.innerHTML += c;

        //const currentProjectIndex = i+1-projectIndexOffset; // index in projects array
        const currentSectionIndex = currentProjectIndex+projectIndexOffset; // index in pages/sections

        onSectionVisible[currentSectionIndex] = function() {
            initProjectSection(currentProjectIndex, currentSectionIndex);
        };

        onSectionGone[currentSectionIndex] = function() {
            closeProjectSection(currentProjectIndex, currentSectionIndex);
        };

        loadScene[currentProjectIndex] = () => {
            if(proj.type==='phone_scene')
                doLoadPhoneScene(/*same as initProjectSection*/currentProjectIndex, proj.model_path)
            else if(proj.type==='desktop_scene')
                doLoadDesktopScene(/*same as initProjectSection*/currentProjectIndex, proj.video_id)
        }

        i++;
    });
    
}

function init(){
    document.body.style.setProperty('visibility', 'visible');
    documentHeight();

    initSectionsContents(projects);

    let STOSSections = document.querySelectorAll(".sensible-to-orientation-section");
    Array.from(STOSSections).forEach(s => {
        sensibleToOrientationSections.push({
            section: s,
            container: s.querySelector(".section-inside-container"),
            projectIndex: s.querySelector(".project-index"), // null if not a project section
            canvasContainer: s.querySelector('.canvasContainer'), // null if not a project section
        });
    });

    let isLandscape = window.innerHeight<window.innerWidth;
    if(!isLandscape){
        setPortraitStyle();
    }

    // abbr popup
    popup.addEventListener('click', function(){
        popup.classList.remove('overlay_show');
    })
    let abbrs = document.querySelectorAll("abbr");
    Array.from(abbrs).forEach(abbr => {
        let title = abbr.getAttribute("title").replaceAll(" •", "<br/> •");
        abbr.addEventListener('click', function() {
            popup.querySelector('h3').innerHTML = abbr.innerHTML;
            popup.querySelector('.content p').innerHTML = title; // title
            popup.classList.add('overlay_show');
        });
    });

    window.addEventListener( 'resize', onWindowResize );
}

function onWindowResize() {
    documentHeight();
    let isLandscape = window.innerHeight<window.innerWidth;
    if(!isLandscape){
        setPortraitStyle();
    }else{
        // landscape
        sensibleToOrientationSections.forEach(sectionWrap => {
            // title and description
            sectionWrap.container.children[0].classList.remove('w-full');
            sectionWrap.container.children[0].classList.add('w-1/2');
            sectionWrap.container.children[0].classList.add('h-full');
            sectionWrap.container.children[0].classList.remove('h-1/2');
            //sectionWrap.container.children[0].classList.remove('w-3-on5');

            // canvas container
            sectionWrap.container.children[1].classList.remove('w-full');
            sectionWrap.container.children[1].classList.add('h-full');
            sectionWrap.container.children[1].classList.remove('h-3on5');
            sectionWrap.container.children[1].classList.add('w-3-on5');
            sectionWrap.container.children[1].classList.remove('bottom-0');
            sectionWrap.container.children[1].classList.remove('left-0');
            sectionWrap.container.children[1].classList.add('right-0.5');

            if(sectionWrap.projectIndex!=null){
                // project index
                sectionWrap.projectIndex.classList.add('px-10');
                sectionWrap.projectIndex.classList.add('py-10');
                sectionWrap.projectIndex.classList.remove('px-4');
                sectionWrap.projectIndex.classList.remove('py-4');
            } // else: not a project section
        });

        // skills section
        mySkillsSection.container.children[0].
            children[0].classList.add('left-1/4');
        mySkillsSection.container.children[0].
            children[0].classList.add('px-10');
        mySkillsSection.container.children[0].
            children[0].classList.remove('px-4');
        mySkillsSection.container.children[1].
            children[0].classList.add('left-10perc');

    }
}


init();




/**
 * 01handleSections.js
 */
import 'animate.css';

const 
    // titleIndex = 0, // first section
    mySelfIndex = 0, // second section
    mySkillsIndex = projects.length + projectIndexOffset; // last section

// title
// onSectionVisible[titleIndex] = function() {
//     fadeInElement(titleSection.container);
// };
// myself
onSectionVisible[mySelfIndex] = function() {
    fadeInElement(myselfSection.container);
};
// skills
onSectionVisible[mySkillsIndex] = function() {
    fadeInElement(mySkillsSection.container);
};


// title
// onSectionGone[titleIndex] = function() {
//     titleSection.container.classList.add("invisible");
// };
// myself
onSectionGone[mySelfIndex] = function() {
    myselfSection.container.classList.add("invisible");
};
// skills
onSectionGone[mySkillsIndex] = function() {
    popup.classList.remove('overlay_show');
    mySkillsSection.container.classList.add("invisible");
};

const initProjectSection = (/*project index*/i, /*page index*/ p_i) => {
    let sectionWrapper = sensibleToOrientationSections[i];
    initCanvas(i);
    animateCanvas();
    fadeInElement(sectionWrapper.container, fadeInElement, [sectionWrapper.canvasContainer]);
}

const closeProjectSection = (/*project index*/i, /*page index*/ p_i) => {
    sensibleToOrientationSections[i].container.classList.add("invisible");
    sensibleToOrientationSections[i].canvasContainer.classList.add("invisible");
    resetCanvas();
}

const fadeInElement = (elem, doAfter, args) => {
    animateCSS(elem, 'fadeIn').then((message) => {
        // Do something after the animation
        if(doAfter)
            doAfter.apply(this, args)
    });
    elem.classList.remove("invisible");
};

const animateCSS = (node, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName);
            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, {once: true});
});




/**
 * canvasMain.js
 */

import * as THREE from 'three';
import gsap from 'gsap'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

// canvas stuff
let renderer, scene, camera;
let group;
let ambientLight;

let animationId;

let canvasContainerWidth, canvasContainerHeight, windowRatio;
let canvasContainers = document.querySelectorAll(".canvasContainer");
let canvases = document.querySelectorAll("canvas");
let currentCanvasContainer;
let distanceFactor;
let modelHighlighted = false;
let transitionCompleted = false;

//var plane = new THREE.Plane(new THREE.Vector3(100, 100, 100), 0);
var mouse = new THREE.Vector2();
var raycaster = new THREE.Raycaster();
var intersects = new THREE.Vector3();
//let maxXCoordinateValue, maxYCoordinateValue;
//let minXCoordinateValue, minYCoordinateValue;

let currentModelIndex = -1;

// pc monitor
let videoTexture = null, 
    video,
    pcMonitorModel = null;

function initCanvas(index){
    currentModelIndex = index;
    windowRatio = window.innerWidth/window.innerHeight;
    //let isLandscape = window.innerHeight<window.innerWidth;
    currentCanvasContainer = canvasContainers[index];
    let currentCanvas = canvases[index];
    modelHighlighted = false;
    transitionCompleted = false;

    canvasContainerWidth = currentCanvasContainer.offsetWidth;
    canvasContainerHeight = currentCanvasContainer.offsetHeight;
    distanceFactor = getDistanceFactor();

    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(
        28, 
        currentCanvasContainer.offsetWidth/currentCanvasContainer.offsetHeight, 
        0.1, 
        300
    );
    renderer = new THREE.WebGLRenderer({
        canvas: currentCanvas,
        antialias:true,
        alpha: true
    });

    renderer.setPixelRatio(window.devicePixelRatio*1.3);
    renderer.setSize(currentCanvasContainer.offsetWidth, currentCanvasContainer.offsetHeight);
    renderer.outputEncoding = THREE.sRGBEncoding;
    camera.position.setZ(12);

    // set group up
    group = new THREE.Group();

    // ambient light
    ambientLight = new THREE.AmbientLight(0xffffff, 1.25);
    scene.add(ambientLight)

    loadScene[index]();

    //scene.add(new THREE.PlaneHelper( plane, 100, 0xffff00 ));

    window.addEventListener( 'resize', onResizeUpdateValues );
}

function animateCanvas(){
    animationId = requestAnimationFrame(animateCanvas);
    if(videoTexture!=null)
        videoTexture.needsUpdate = true;
    renderer.render(scene, camera);
}

function resetCanvas(){
    currentModelIndex = -1;
    cancelAnimationFrame(animationId);
    models = [];
    resetVideo();
    window.removeEventListener( 'mousedown', onMouseDown);
    window.removeEventListener( 'touchstart', onMouseDown);
    renderer.clear()
}

function onResizeUpdateValues() {
    //let isLandscape = window.innerHeight<window.innerWidth;
    //camera.fov = 2;
    camera.aspect = currentCanvasContainer.offsetWidth/currentCanvasContainer.offsetHeight;
    camera.updateProjectionMatrix();
    renderer.setSize( currentCanvasContainer.offsetWidth, currentCanvasContainer.offsetHeight );

    canvasContainerWidth = currentCanvasContainer.offsetWidth;
    console.log("pp:"+canvasContainerWidth)
    canvasContainerHeight = currentCanvasContainer.offsetHeight;
    windowRatio = window.innerWidth/window.innerHeight;
    distanceFactor = getDistanceFactor();
    updateModelsPosition();
    //getCanvasInnerCoordinatesBounds();
}

function getCanvasInnerCoordinatesBounds(){
    let vec2 = new THREE.Vector2();
    vec2.x = 1;
    vec2.y = 1;
    raycaster.setFromCamera(vec2, camera);
    raycaster.ray.intersectPlane(plane, intersects);
    maxXCoordinateValue = intersects.x;
    maxYCoordinateValue = intersects.y;

    vec2.x = -1;
    vec2.y = -1;
    raycaster.setFromCamera(vec2, camera);
    raycaster.ray.intersectPlane(plane, intersects);
    minXCoordinateValue = intersects.x;
    minYCoordinateValue = intersects.y;

    console.log(maxXCoordinateValue);
    console.log(minXCoordinateValue);
}

let models = [];
let phoneAnimationValues = {
    entranceStartPointBaseValue: 8, 
    entranceBaseDuration: 2,
    entranceDurationFactor: 0.3,
    transitionDuration: 0.7,
    topZValue: 3,
    originalRotation: 4.26, // -1.58
    highlightedRotation: 4.69,
    originalScale: 0.8,
    highlightedMidStepScale: 0.85,
    highlightedFinalStepScale: 0.9,
}

// load models
function loadModel(url) {
    return new Promise(resolve => {
        new GLTFLoader().load(url, resolve);
    });
}

const doLoadPhoneScene = (i, model_path) => {
    let p1 = loadModel(model_path+'/1/phone.gltf').then(result => {  
        models[0] = result.scene; 
    });
    let p2 = loadModel(model_path+'/2/phone.gltf').then(result => {  
        models[1] = result.scene; 
    });
    let p3 = loadModel(model_path+'/3/phone.gltf').then(result => {  
        models[2] = result.scene; 
    });

    //if all Promises resolved 
    Promise.all([p1,p2,p3]).then(() => {
        if(currentModelIndex!=i) return;
        //add model to the scene
        let isLandscape = window.innerHeight<window.innerWidth;
        addModelToScene(0, models[0], isLandscape);
        addModelToScene(1, models[1], isLandscape);
        addModelToScene(2, models[2], isLandscape);
        scene.add(group);
        window.addEventListener( 'mousedown', onMouseDown);
        window.addEventListener( 'touchstart', onMouseDown);
    });
};

let getFromPos = {
    x: function(i){
            return (i-1) * distanceFactor;
        },
    y: function(i){
            return (i-1) * 0.7;
        },
    z: function(i){
            return (-i+1) * 0.4;
        },
}

function setInitialModelPosition(i, modelScene, isLandscape){
    if(isLandscape){
        let x = getFromPos.x(i);
        let z = getFromPos.z(i);
        modelScene.position.set(x,phoneAnimationValues.entranceStartPointBaseValue+i,z);
    }else{
        let y = getFromPos.y(i);
        let z = getFromPos.z(i);
        modelScene.position.set(phoneAnimationValues.entranceStartPointBaseValue+i,y,z);
    }
}

function setFinalModelPosition(i, modelScene, isLandscape){
    let tl = gsap.timeline();
    if(isLandscape){
        let y = getFromPos.y(i);
        tl.to(modelScene.position, { 
            y: y, 
            duration: phoneAnimationValues.entranceBaseDuration+i*phoneAnimationValues.entranceDurationFactor,
            onComplete: function(){
                if(i==2) // last model
                    transitionCompleted = true;
            } 
        });
    }else{
        let x = getFromPos.x(i);
        tl.to(modelScene.position, {
            x: x, 
            duration: phoneAnimationValues.entranceBaseDuration+i*phoneAnimationValues.entranceDurationFactor,
            onComplete: function(){
                if(i==2) // last model
                    transitionCompleted = true;
            } 
        });
    }
}

function addModelToScene(i, modelScene, isLandscape){
    let y = getFromPos.y(i);
    let sc = phoneAnimationValues.originalScale*getPhoneScaleFactor();
    modelScene.scale.set(sc,sc,sc);
    modelScene.rotation.set(0, phoneAnimationValues.originalRotation, 0);
    setInitialModelPosition(i, modelScene, isLandscape);

    group.add(modelScene);

    setFinalModelPosition(i, modelScene, isLandscape);
}

function getDistanceFactor(){
    if(canvasContainerWidth <= 620)
        return 1;
    if(canvasContainerWidth <= 790)
        return 1.2;
    return 1.3;
}

function getPhoneScaleFactor(){
    if(canvasContainerWidth <= 950)
        return 1.0;
    return 1.2;
}

function getMonitorScaleFactor(){
    if(canvasContainerWidth <= 680 && ! window.matchMedia("(max-width: 600px)").matches)
         return 0.9;
    if(canvasContainerWidth <= 790 && ! window.matchMedia("(max-width: 600px)").matches){
        return 0.95;
    }
    if(canvasContainerWidth <= 790)
        return 1.1;
    if(canvasContainerWidth <= 991)
        return 1.2;
    return 1.3;
}

function updateModelsPosition(){
    try{
        for(let i = 0; i<models.length;i++){
            let x = getFromPos.x(i);
            let y = getFromPos.y(i);
            let z = getFromPos.z(i);
            models[i].position.set(x,y,z);
            let sc = phoneAnimationValues.originalScale*getPhoneScaleFactor();
            models[i].scale.set(sc,sc,sc);
            models[i].rotation.set(0, phoneAnimationValues.originalRotation, 0);
        }
        modelHighlighted = false;

        // reset monitor pc
        if(pcMonitorModel!=null){
            pcMonitorModel.scale.set(
                pcMonitorModelValues.originalScale*getMonitorScaleFactor(),
                pcMonitorModelValues.originalScale*getMonitorScaleFactor(),
                pcMonitorModelValues.originalScale*getMonitorScaleFactor()
            )
            pcMonitorModel.position.set(
                pcMonitorModelValues.originalPosition.x, 
                pcMonitorModelValues.originalPosition.y, 
                pcMonitorModelValues.originalPosition.z
            );
        }

        tl.clear();
        tl = gsap.timeline({onReverseComplete:reverseFunction}); // reset
    }catch(e){
        console.log(e);
    }
}


/**
 * PC monitor model -------------------------------------------------------
 * ------------------------------------------------------------------------
 */
 let pcMonitorModelValues = {
    originalScale: 2.48,
    originalPosition: {x:0,y:0.3,z:0},
}
const doLoadDesktopScene = (index, videoId) => {
    const loader = new THREE.ObjectLoader();
    loader.load(
        // resource URL
        "./models/pc/monitor.json",
    
        // onLoad callback
        // Here the loaded data is assumed to be an object
        function ( obj ) {
            if(currentModelIndex!=index) return;
            // Add the loaded object to the scene
            //console.log(obj)
            pcMonitorModel = obj;
            obj.position.set(
                pcMonitorModelValues.originalPosition.x, 
                pcMonitorModelValues.originalPosition.y, 
                pcMonitorModelValues.originalPosition.z
            );
            obj.scale.set(
                pcMonitorModelValues.originalScale*getMonitorScaleFactor(), 
                pcMonitorModelValues.originalScale*getMonitorScaleFactor(), 
                pcMonitorModelValues.originalScale*getMonitorScaleFactor()
            );
            obj.rotation.set(0,-0.3,0);
            obj.children[0].material = getScreenMaterial(videoId);
            scene.add( obj );
        },
    
        // onProgress callback
        function ( xhr ) {
            console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
        },
    
        // onError callback
        function ( err ) {
            console.error( 'An error happened' );
        }
    );
}
 
const getScreenMaterial = (id) => {
    // video texture
    video = document.getElementById(id);

    videoTexture = new THREE.VideoTexture(video);

    // post process texture
    videoTexture.minFilter = THREE.LinearFilter; // how texture is sampled when texel < 1 pixel
    videoTexture.magFilter = THREE.LinearFilter; // how texture is sampled when texel > 1 pixel

    var movieMaterial = new THREE.MeshBasicMaterial({
        map: videoTexture, // set material.map property to video texture
        side: THREE.FrontSide, // show video on front side
        toneMapped: false, // turn off tone mapping - used to show HDR on monitor/device
    })

    video.currentTime = 0;
    video.play();
    return movieMaterial;
}

const resetVideo = () => {
    if(video!=null)
        video.currentTime = 0;
    videoTexture = null;
    video = null;
    pcMonitorModel = null;
}


/**
 * Handle tap on models ---------------------------------------------------
 * ------------------------------------------------------------------------
 */
let ontop = 0; // Javascript in the browser is singled threaded
let tl = gsap.timeline({onReverseComplete:reverseFunction});
function reverseFunction(){
    tl.clear();
    tl = gsap.timeline({onReverseComplete:reverseFunction}); // reset
    transitionCompleted = true;
    modelHighlighted = false;
}
function showModelIfselected(index){
    // i want to highlight a model (it would not be models[index])
    intersects = raycaster.intersectObject(models[index], true);
    if(intersects.length > 0){
        // click on models[index] detected

        // hide other models
        if(index==0) hideModels(1, 2, tl)
        if(index==1) hideModels(0, 2, tl)
        if(index==2) hideModels(0, 1, tl)

        // highlight models[index]
        tl.to(models[index].position, { x:0, y:0, z: phoneAnimationValues.topZValue, 
            duration: phoneAnimationValues.transitionDuration,
            onComplete: function(){
                transitionCompleted = true;
                modelHighlighted = true;
            }, 
        }, "-=0.7")
        .to(models[index].scale, { 
            x: phoneAnimationValues.highlightedFinalStepScale, 
            y: phoneAnimationValues.highlightedFinalStepScale, 
            z: phoneAnimationValues.highlightedFinalStepScale, 
            duration: 0.5}, "<")
        .to(models[index].rotation, { y: phoneAnimationValues.highlightedRotation, duration: 0.5});
        return true;
    }
    // no click on models[index]
    return false;
}

function hideModels(i, j, tl){
    let isLandscape = window.innerHeight<window.innerWidth;
    let hideDuration = 1;
    if(isLandscape){
        tl
            //model1
            .to(models[i].position, {
                    y: phoneAnimationValues.entranceStartPointBaseValue+i, 
                    duration: hideDuration
                }
            )
            //model2
            .to(models[j].position, {
                    y: phoneAnimationValues.entranceStartPointBaseValue+j, 
                    duration: hideDuration
                }, "<"
            );
    }
    else{
        tl
            //model1
            .to(models[i].position, {
                    x: phoneAnimationValues.entranceStartPointBaseValue+i, 
                    duration: hideDuration
                }
            )
            //model2
            .to(models[j].position, {
                    x: phoneAnimationValues.entranceStartPointBaseValue+j, 
                    duration: hideDuration
                }, "<"
            );
    }
}

function getModelsStartState(index){
    // i want to get original position for highlighted model (it would not be models[index])
    let x = getFromPos.x(index);
    let y = getFromPos.y(index);
    let z = getFromPos.z(index);
    if(models[index].position.z >= phoneAnimationValues.topZValue){
        // get models back to their original position
        tl.reverse();
        return true;
    }
    return false;
}

function onMouseDown(e) {
    if(!transitionCompleted)
        return;
    // there's no running transition

    // if one model is highlighted, get it back to original position
    if(modelHighlighted){
        if(getModelsStartState(ontop)){
            ontop = 0;
            return;
        }
        if(getModelsStartState(aMODn(ontop+1,3))){
            ontop = 0;
            return;
        }
        if(getModelsStartState(aMODn(ontop+2,3))){
            ontop = 0;
            return;
        }
        return;
    }
    // there's no model highlighted
    
    let x,y;
    if(e.type == 'touchstart'/* || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'*/){
        var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
        var touch = evt.touches[0] || evt.changedTouches[0];
        x = touch.pageX;
        y = touch.pageY;
    } else if (e.type == 'mousedown'/* || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'||
                                         e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave'*/) {
        x = e.clientX;
        y = e.clientY;
    }

    let isLandscape = window.innerHeight<window.innerWidth;
    if( isLandscape && x < window.innerWidth-canvasContainerWidth || 
            !isLandscape && y < window.innerHeight-canvasContainerHeight)
        return;
    transitionCompleted = false;
    // click is inside canvas

    if(isLandscape){
        let newX = x - (window.innerWidth-canvasContainerWidth); // click coord from start of canvas
        mouse.x = ( newX / canvasContainerWidth ) * 2 - 1;
        mouse.y = - ( y / currentCanvasContainer.offsetHeight ) * 2 + 1;
    }else{
        let newY= y - (window.innerHeight-canvasContainerHeight); // click coord from start of canvas
        mouse.x = ( x / currentCanvasContainer.offsetWidth ) * 2 - 1;
        mouse.y = - ( newY / canvasContainerHeight ) * 2 + 1;
    }
    raycaster.setFromCamera(mouse, camera);

    if(showModelIfselected(ontop)){
        return;
    }
    if(showModelIfselected(aMODn(ontop+1,3))){
        ontop = aMODn(ontop-1,3);
        return;
    }
    if(showModelIfselected(aMODn(ontop+2,3))){
        ontop = aMODn(ontop-2,3);
        return;
    }
    transitionCompleted = true;
}

function aMODn(a,n){
    return ((a % n) + n) % n;
}



/**
 * marqueeLikeContentScrolling.js
 */
const root = document.documentElement;
const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
const marqueeContent = document.querySelector("ul.marquee-content");

root.style.setProperty("--marquee-elements", marqueeContent.children.length);

for(let i=0; i<marqueeElementsDisplayed; i++) {
    marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
}



/**
 * mySnapScroll.js
 */

// import gsap from 'gsap';
import { Observer } from 'gsap/Observer'

gsap.registerPlugin(Observer);

const handleVisibleSection = (goneSectionIndex, visibleSectionIndex) => {
  onSectionGone[goneSectionIndex](); // defined in handleSection.js
  onSectionVisible[visibleSectionIndex](); // defined in handleSection.js
};

let sections = document.querySelectorAll("section"),
  bgs = document.querySelectorAll(".bg"),
  headings = gsap.utils.toArray(".section-heading"),
  outerWrappers = gsap.utils.toArray(".outer"),
  innerWrappers = gsap.utils.toArray(".inner"),
  currentIndex = 0,
  animating = false;

gsap.set(outerWrappers, { yPercent: 100 });
gsap.set(innerWrappers, { yPercent: -100 });

// set first section visible
gsap.set(outerWrappers[0], { yPercent: 0 });
gsap.set(innerWrappers[0], { yPercent: 0 });
gsap.set(sections[0], { autoAlpha: 1, zIndex: 1 });
gsap.set(bgs[0], { yPercent: 0 });

function gotoSection(index, direction) {
  if(index < 0){
      currentIndex = 0;
      animating = false;
      return;
  }
  if(index > sections.length - 1){
      currentIndex = index-1;
      animating = false;
      return;
  }
  animating = true;
  let fromTop = direction === -1,
      dFactor = fromTop ? -1 : 1,
      tl = gsap.timeline({
        defaults: { duration: 0.8, ease: "power1.inOut" },
        onComplete: () => {
            animating = false;
            handleVisibleSection(index-direction, index);
        }
      });

  gsap.set(sections[currentIndex], { zIndex: 0 });
  tl.to(bgs[currentIndex], { yPercent: -99 * dFactor })
    .set(sections[currentIndex], { autoAlpha: 0 });

  gsap.set(sections[index], { autoAlpha: 1, zIndex: 1 });
  tl.fromTo([outerWrappers[index], innerWrappers[index]], { 
      yPercent: i => i ? -100 * dFactor : 100 * dFactor
    }, { yPercent: 0 }, 0)
    .fromTo(bgs[index], { yPercent: 99 * dFactor }, { yPercent: 0 }, 0);

  currentIndex = index;
}

Observer.create({
    type: "wheel,touch",
    wheelSpeed: -1,
    onDown: () => !animating && gotoSection(currentIndex - 1, -1),
    onUp: () => !animating && gotoSection(currentIndex + 1, 1),
    tolerance: 40,
    preventDefault: true
});

// original horizontal version: https://codepen.io/GreenSock/pen/xxWdeMK




